import { useEffect, useRef } from "react";
import { CommandMenu } from "./command-menu";
import { useCommandMenu } from "./use-command-menu";

export const CommandMenuWrapper = () => {
    const { isOpen, open, close } = useCommandMenu();
    const escapeJustPressedRef = useRef(false);

    // Keyboard shortcut globale Cmd+K / Ctrl+K
    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            // Gestisci ESC quando il menu è aperto
            if (isOpen && e.key === "Escape") {
                e.preventDefault();
                e.stopPropagation();
                escapeJustPressedRef.current = true;
                close();
                // Reset del flag dopo un breve delay
                setTimeout(() => {
                    escapeJustPressedRef.current = false;
                }, 200);
                return;
            }

            // Non aprire il menu se ESC è stato appena premuto o se il menu è aperto
            if (!isOpen && !escapeJustPressedRef.current) {
                const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
                const isCmdK = isMac ? e.metaKey && e.key === "k" : e.ctrlKey && e.key === "k";

                if (isCmdK) {
                    e.preventDefault();
                    e.stopPropagation();
                    open();
                }
            }
        };

        window.addEventListener("keydown", handleKeyDown, true); // Usa capture phase
        return () => {
            window.removeEventListener("keydown", handleKeyDown, true);
        };
    }, [isOpen, open, close]);

    return <CommandMenu isOpen={isOpen} onClose={close} />;
};

